export default angular
    .module('syCharts', [])
    /**
     * @ngdoc service
     * @name syCharts.service:ChartService
     * @description
     * Creates a service to handle chart functions.
     */
    // @ngInject
    .service('ChartService', [
        function () {
            this.createColumnChart = function (header, series, title, subTitle, dataFormat) {
                if (series[0].data.length > 0 && !series[0].data[0].color) {
                    var colours = Highcharts.getOptions().colors
                    for (var i = 0; i < series[0].data.length; i++) {
                        var point = series[0].data[i]
                        point.color = colours[i]
                    }
                }
                return {
                    chart: {
                        type: 'column'
                    },
                    series: series,
                    title: {
                        text: title
                    },
                    subtitle: {
                        text: subTitle
                    },
                    plotOptions: {
                        column: {
                            dataLabels: {
                                enabled: true,
                                format: dataFormat,
                                crop: false,
                                overflow: 'none'
                            },
                            groupPadding: 0,
                            pointPadding: 0.25
                        }
                    },
                    tooltip: {
                        headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
                        pointFormat:
                            '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
                            '<td style="padding:0"><b>${point.y:.0f}</b></td></tr>',
                        footerFormat: '</table>',
                        shared: true,
                        useHTML: true
                    },
                    xAxis: {
                        categories: header,
                        tickLength: 0,
                        type: 'category'
                    },
                    yAxis: {
                        tickInterval: 1000,
                        title: {
                            text: null
                        }
                    },
                    legend: {
                        enabled: false
                    },
                    credits: {
                        enabled: false
                    }
                }
            }
        }
    ])
    /**
     * @ngdoc directive
     * @name syCharts.directive:syChart
     * @description
     * Creates a controller to track a chart.
     */
    // @ngInject
    .directive('syChart', [
        function () {
            var getIEVersion = function () {
                var agent = navigator.userAgent
                var reg = /MSIE\s?(\d+)(?:\.(\d+))?/i
                var matches = agent.match(reg)
                if (matches != null) {
                    return {
                        major: matches[1],
                        minor: matches[2]
                    }
                }
                return {
                    major: '-1',
                    minor: '-1'
                }
            }
            return {
                restrict: 'A',
                scope: {
                    chartModel: '=syChartModel'
                },
                link: function ($scope, $element) {
                    setTimeout(function () {
                        if ($scope.chartModel) {
                            $element.highcharts($scope.chartModel)
                            if (getIEVersion().major === '10') {
                                for (var i = 0; i < $element.highcharts().series.length; i++) {
                                    $element.highcharts().series[i].hide()
                                    $element.highcharts().series[i].show()
                                }
                            }
                        }
                    }, 500)
                }
            }
        }
    ])
